import { Bloco, Recarregando } from "./styled";

const VARIANTES = ["cartao", "linha", "texto", "barras", "grafico"];

/**
 * Esqueleto de carregamento: placeholders cinza pulsando no formato do que vai chegar.
 * Substitui o overlay `Loading` (modal "Aguarde") nas cargas DENTRO da mesma tela --
 * listas, filtros, paginacao, detalhes. O overlay fica so para a entrada entre telas.
 *
 *  - variante "cartao": cartoes de grade (capa + titulo + duas linhas)
 *  - variante "linha":  linhas de lista/tabela (avatar + texto)
 *  - variante "texto":  paragrafos
 *  - variante "barras": ranking horizontal (relatorios por localidade/especie)
 *  - variante "grafico": cartao de grafico (evolucao no tempo)
 *
 * `rotulo` e lido por leitores de tela (role=status); os blocos sao aria-hidden.
 * Com prefers-reduced-motion a animacao e desligada (fica o cinza fixo).
 */
function Esqueleto({ variante = "cartao", quantidade = 6, rotulo = "Carregando", className = "", ...resto }) {
  const v = VARIANTES.includes(variante) ? variante : "cartao";
  const n = Math.max(1, Math.min(Number(quantidade) || 1, 24));

  return (
    <Bloco className={`esqueleto v-${v} ${className}`.trim()} role="status" aria-live="polite" aria-busy="true" {...resto}>
      <span className="so-leitor">{rotulo}…</span>
      {Array.from({ length: n }).map((_, i) => (
        <div className="item" key={i} aria-hidden="true" data-testid="esqueleto-item">
          {v === "cartao" && <><div className="capa pulsa" /><div className="titulo pulsa" /><div className="l1 pulsa" /><div className="l2 pulsa" /></>}
          {v === "linha" && <><div className="avatar pulsa" /><div className="textos"><div className="l1 pulsa" /><div className="l2 pulsa" /></div></>}
          {v === "texto" && <><div className="l1 pulsa" /><div className="l1 pulsa" /><div className="l2 pulsa" /></>}
          {v === "barras" && <><div className="rotulo pulsa" /><div className="barra pulsa" style={{ width: `${88 - ((i * 17) % 60)}%` }} /></>}
          {v === "grafico" && <><div className="titulo pulsa" /><div className="area">{[55, 80, 40, 95, 65, 75, 50, 85, 60, 90, 45, 70].map((h, k) => <div key={k} className="coluna pulsa" style={{ height: `${h}%` }} />)}</div></>}
        </div>
      ))}
    </Bloco>
  );
}

export { Recarregando };
export default Esqueleto;
